import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import ProgressBar from '../progress-bar';
import { getEmailSignature } from './reducer';
import { getUser } from '../../modules/Auth/AuthReducer';
import RequestSignatureForm from './RequestSignatureForm';
import CheckUserEmailSignature from './CheckUserEmailSignature';

class RequiredUserEmailSignature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isWaiting: false,
    };
    this.hanldeShowLoading = this.hanldeShowLoading.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.verified && nextProps.verified && this.state.isWaiting) {
      const el = (<div>Your email <code>{nextProps.user.email}</code> is now verified</div>);
      this.context.addNotification(el, { type: 'success', autoClose: false });
      this.props.onVerified();
    }
  }

  hanldeShowLoading(isWaiting) {
    if (isWaiting) {
      this.setState({ isWaiting });
    }
  }

  renderLoading() {
    return (
      <div className="well">
        <p />
        <p>Required email signature</p>
        <ProgressBar />
        <p />
      </div>
    );
  }

  renderError() {
    return (
      <div className="alert alert-danger">Something went wrong. Please try again later</div>
    );
  }

  render() {
    const {
      children, onCancel, collectorId,
    } = this.props;
    return (
      <CheckUserEmailSignature collectorId={collectorId}>
        {({ verified, error, loading, loaded }) => {
          const displaySpinner = (loading || !loaded) && !error;
          if (displaySpinner) {
            return this.renderLoading();
          }
          if (error) {
            return this.renderError();
          }
          if (!verified) {
            return (
              <div>
                <Modal.Header>
                  <Modal.Title>Need Authorization to Send Email on Your Behalf</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <RequestSignatureForm onCancel={onCancel} showLoading={this.hanldeShowLoading} />
                </Modal.Body>
              </div>
            );
          }
          return children;
        }}
      </CheckUserEmailSignature>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const user = getUser(state);
  const info = getEmailSignature(state, user.email);
  return {
    verified: info.signature === 'verified',
    user,
  };
}

RequiredUserEmailSignature.propTypes = {
  children: PropTypes.node,
  verified: PropTypes.bool,
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
  onCancel: PropTypes.func,
  onVerified: PropTypes.func,
  collectorId: PropTypes.string,
};
RequiredUserEmailSignature.defaultProps = {
  children: null,
  verified: false,
  onCancel: null,
  onVerified: () => {},
  collectorId: null,
};
RequiredUserEmailSignature.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};


export default connect(mapStateToProps)(RequiredUserEmailSignature);
